import { useSyncExternalStore } from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Check, Palette } from 'lucide-react'
import { getTheme, serverTheme, setDugoutTheme, subscribeTheme, type DugoutTheme } from '../../theme/themes'

const choices: { value: DugoutTheme; label: string; description: string }[] = [
  { value: 'forest', label: 'Forest', description: 'Deep greens & gold' },
  { value: 'paper', label: 'Paper', description: 'Warm paper & rust' },
  { value: 'night-game', label: 'Night Game', description: 'Midnight & lime' },
]

export function DugoutThemePicker({ onOpen }: { onOpen?: () => void }) {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, serverTheme)
  const current = choices.find(choice => choice.value === theme)!
  return <DropdownMenu.Root modal={false} onOpenChange={open => { if (open) onOpen?.() }}>
    <DropdownMenu.Trigger asChild>
      <button type="button" className="dugout-theme-trigger" aria-label={`Choose theme, current theme: ${current.label}`} title="Choose theme"><Palette size={21} strokeWidth={1.7} aria-hidden="true" /></button>
    </DropdownMenu.Trigger>
    <DropdownMenu.Portal>
      <DropdownMenu.Content className="dugout-theme-panel" align="end" sideOffset={10} collisionPadding={12}>
        <DropdownMenu.Label className="theme-panel-heading">Choose a theme</DropdownMenu.Label>
        <DropdownMenu.RadioGroup aria-label="Color theme" value={theme} onValueChange={value => { const choice = choices.find(item => item.value === value); if (choice) setDugoutTheme(choice.value) }}>
          {choices.map(choice => <DropdownMenu.RadioItem key={choice.value} value={choice.value} textValue={choice.label} className="theme-choice" data-theme-choice={choice.value}>
            <span className="theme-choice-swatch" aria-hidden="true">Aa<span /></span>
            <span className="theme-choice-copy"><span className="theme-choice-name">{choice.label}</span><span className="theme-choice-description">{choice.description}</span></span>
            <span className="theme-choice-check"><DropdownMenu.ItemIndicator><Check size={18} aria-hidden="true" /></DropdownMenu.ItemIndicator></span>
          </DropdownMenu.RadioItem>)}
        </DropdownMenu.RadioGroup>
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>
}
